import { ReactNode } from 'react'
import classNames from 'classnames'
import { ReactFC } from 'common/types/ReactFC'

import { generateSrcSet } from 'project/image-proxy-web'
import useWindowSize from 'components/util/useWindowSize'

type PartnerHeroBannerType = {
  cta?: ReactNode
  robotImage: {
    src: string
    height: number
    width: number
  }
  robotImageMobile?: {
    src: string
    height: number
    width: number
  }
  partnershipLogo?: ReactNode
  title: string | ReactNode
  imageContainerWidth?: string
  description: string | ReactNode
  contentContainerStyle?: React.CSSProperties
  ctaBtn?: ReactNode
  imageContainerClassName?: string
}

const PartnerHeroBanner: ReactFC<PartnerHeroBannerType> = ({
  contentContainerStyle,
  ctaBtn,
  description,
  imageContainerClassName,
  imageContainerWidth,
  partnershipLogo,
  robotImage,
  robotImageMobile,
  title,
}) => {
  const size = useWindowSize()
  return (
    <div className='container-fluid ps-4 ps-lg-26 pe-4 pt-6 pt-lg-0'>
      <div className='d-flex flex-column flex-lg-row'>
        <div className='d-flex flex-column flex-1 pt-xl-15 pt-10'>
          <div
            className='d-flex flex-column text-center text-lg-start pb-lg-7'
            style={contentContainerStyle}
          >
            {partnershipLogo && partnershipLogo}
            <h1 className='fs-fluid-40-80 lh-114 mb-4 mt-3 mt-lg-3'>{title}</h1>
            <div className='fs-fluid-24-28 fw-semibold'>{description}</div>
            {size.isLgOrHigher && <div className='d-flex'>{ctaBtn}</div>}
          </div>
        </div>

        <div
          className={classNames(
            'd-flex flex-column align-items-center',
            imageContainerClassName,
          )}
          style={{
            width: imageContainerWidth,
          }}
        >
          <img
            {...generateSrcSet(
              robotImage.src,
              robotImage.width,
              robotImage.height,
            )}
            loading='eager'
            fetchPriority='high'
            className={classNames('h-100 img-fluid object-fit-contain', {
              'd-none d-lg-block': !!robotImageMobile,
            })}
            height={robotImage.height}
            width={robotImage.width}
            alt='HaiRo™ robot mascot'
          />
          {robotImageMobile && (
            <img
              {...generateSrcSet(
                robotImageMobile.src,
                robotImageMobile.width,
                robotImageMobile.height,
              )}
              fetchPriority='high'
              loading='eager'
              className='h-100 img-fluid object-fit-contain d-lg-none'
              height={robotImageMobile.height}
              width={robotImageMobile.width}
              alt='HaiRo™ robot mascot'
            />
          )}
        </div>
      </div>
      {!size.isLgOrHigher && ctaBtn}
    </div>
  )
}

export default PartnerHeroBanner
